<template>
  <div class="too-cont">
      <slot name="left"></slot>
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: '',
  mounted () {
    
  },
}
</script>

<style lang='scss'  scoped>
.too-cont{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  line-height: 50px;
  color: #000000;
  border-left: 4px solid #165DFF;
  padding: 0px 10px;
  box-sizing: border-box;
  background-color: #F4F4F6;
}

</style>



// WEBPACK FOOTER //
// src/views/account-management/component/too-title.vue